import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Typography,
  InputAdornment,
  makeStyles,
  TableCell
} from '@material-ui/core'
import { SearchInput, StyledFilterIcon, StyledHeadTableCell } from 'pages/administration/styles'
import { AdminContainer } from '../../AdminContainer'
import { lighten } from 'polished'
//@ts-ignore
import { useTheme } from 'styled-components'
import { Search } from '@material-ui/icons'
import { Loader } from 'components/core/loader'
import { ConfirmationDialog } from 'components/core/modal'
import { useMemo, useState } from 'react'
import { useReportedUser } from './hooks/useReportedUser'
import styled from 'styled-components'
import { ReportedUserType } from 'common/types/content.types'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useContent } from '../../../../content/hooks/useContent'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useEffect } from 'react'
import SearchFilterDrawer  from './components/SearchFilterDrawer'
import InfiniteScroll from 'react-infinite-scroll-component'
import { AnalyticUserType, useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { StyledReportContentIconButton } from '../styled'
import { ReportModal } from './components/ReportModal'
import { CustomIconContextMenu } from 'components/core/actions-menu-noborder/CustomIconContextMenu'
import { ReactComponent as ActionContextIcon } from 'icons/action-context-icon.svg'
import { SuspendUser } from 'common/icon-components/SuspendUser'
import { BlockUser } from 'common/icon-components/BlockUser'
import { observer } from 'mobx-react'
import { ReportedContentState } from 'models/reported-content/reported-content.store'
import { Button } from 'common/atoms/Button/Button'


export const StyledTableCell = styled(TableCell)`
  && {
    color: ${props => props.theme.colors.accent1};
    background-color: ${props => props.theme.colors.supplementary1};
    border-bottom-color: ${props => props.theme.colors.supplementary};
    border-width: 3;
    cursor: pointer;
    max-width: 11.25rem;
    overflow-wrap: break-word;
  }
`

export const StyledUnblockMessage = styled(Typography)`
  && {
    color: ${props => props.theme.colors.accent1};
    font-weight: bold;
    font-size: 16px;
    margin: 0.5em;
    text-align: center;
  }
`

const StyledTableRow = styled(TableRow)`
  border: 0;
`
const StyledEndText = styled(Typography)`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: ${props => props.theme.colors.accent1};
  padding-top: 0.9rem;
`

const StyledReportedUserTypeTextWrapper = styled(Box)`
  && {
    display: flex;
    align-items: center;
    padding: 0rem 1.063rem;
  }
`

const StyledReportedUserTypeText = styled.span`
  && {
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-left: 1.063rem;
  }
`
const useStyle = props => {
  return useMemo(
    () => ({
      infiniteScroll: { overflowX: 'hidden', width: '100%' }
    }),
    [props]
  )
}

const ReportedUserList = props => {
  const styles = useStyle(props)
  const theme = useTheme()
  const { backendUser, backendPartner } = useAuth()
  const { setIsDrawerOpen, filters } = ReportedContentState
  const {
    reportedUsers,
    setReportedUsers,
    listHeadline,
    mode,
    fetchSearchedUsers,
    totalCount,
    isLoading,
    setTotalCount
  } = useReportedUser()
  const getThemeForInput = () => {
    return mode === 'light' ? lighten(0.9, theme.colors.accent1) : theme.colors.accent1
  }

  const useStyles = makeStyles(() => ({
    container: {
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      overflowY: 'auto',
      height: '70vh'
    },
    searchIcon: {
      color: theme.colors.accent,
      cursor: 'pointer'
    },
    searchInputProps: {
      border: 'none',
      color: getThemeForInput()
    },
    search: {
      color: theme.colors.accent,
      cursor: 'pointer'
    }
  }))

  const [openUnblockModal, setOpenUnblockModal] = useState(false)
  const [openUnsuspendModal, setOpenUnsuspendModal] = useState(false)
  const [isConfirmed, setIsConfirmed] = useState(false)
  const [resolution, setResolution] = useState('')

  const { reportedUserActions } = useContent()
  const { notify } = useNotification()
  const classes = useStyles()
  const [userId, setUserId] = useState('')
  const [searchCriteria, setSearchCriteria] = useState('')
  const { handleTracker } = useAnalytics()
  const [page, setPage] = useState(1)

  const handleConfirm = async (eventName: string) => {
    try {
      const payload = {
        resolution
      }
      const unblock = await reportedUserActions(userId, backendUser?.id, payload).then(() => {
        const index = reportedUsers?.findIndex(user => user.id === userId)
        reportedUsers?.splice(index, 1)
        setReportedUsers(reportedUsers)
        setTotalCount(totalCount - 1)
        setOpenUnsuspendModal(false)
        setOpenUnblockModal(false)
        setIsConfirmed(false)
        setResolution('')
        notify('success', 'Access to Obsidi for the user is reactivated')
      })

      const logData = {
        'User ID': backendUser?.id,
        'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
        'Partner ID': backendPartner?.id,
        'Company Name': backendPartner?.name
      }
      if (openUnsuspendModal) {
        logData['Unsuspended User ID'] = userId
      }

      if (openUnblockModal) {
        logData['Unblocked User ID'] = userId
      }
      await handleTracker(AnalyticUserType.ALL, eventName, logData, 'mixpanel', null, backendUser)
      return unblock
    } catch (error) {
      notify('error', 'Failed to reactivated the user!')
      setResolution('')
    }
  }

  const handleResolutionChange = event => {
    const value = event.target.value.slice(0, 250)
    setResolution(value)
  }

  const handleKeyDown = async (event) => {
    const code = event.keyCode ? event.keyCode : event.which

    if (code == 13) {
      const logData = {
        'User ID': backendUser?.id,
        'Account Type': backendUser?.partnerId ? 'Partner' : backendUser?.role,
        'Profile search query': searchCriteria,
        'Profile search results': reportedUsers?.length,
        'Partner ID': backendPartner?.id,
        'Company Name': backendPartner?.name
      }
      await handleTracker(AnalyticUserType.ALL, 'Search Reported User', logData, 'mixpanel', null, backendUser)
    }
  }

  const fetchMore = () => {
    setPage(page + 1)
  }
  const pageSize = 12
  const { status = '' } = { ...filters }

  useEffect(() => {
    fetchSearchedUsers(page, pageSize, searchCriteria, status)
  }, [searchCriteria, page, status])

  const hasMore = totalCount > reportedUsers?.length

  return (
    <AdminContainer title={''}>
      <Box display="flex" bgcolor={theme.colors.bgPrimary} width="100%" p="1.9em">
        <Box justifyContent="center" bgcolor={theme.colors.bgPrimary} width="100%">
          <Typography variant="h6">
            <Box color={theme.colors.accent1} fontWeight="bold" p="0em 0em">
              Reported Users
            </Box>
          </Typography>
          <Box display="flex" alignItems="center">
            <Box
              bgcolor={theme.colors.supplementary}
              borderRadius="5.125em"
              margin="1em 1em 1em 0em"
              height="2.5em"
            >
              <SearchInput
                type="search"
                placeholder="Search..."
                onChange={event => {
                  setSearchCriteria(event.target.value)
                }}
                onKeyDown={handleKeyDown}
                InputProps={{
                  disableUnderline: true,
                  style: {
                    border: 'none',
                    color: getThemeForInput()
                  },
                  endAdornment: (
                    <InputAdornment position="start">
                      <Search className={classes.search} />
                    </InputAdornment>
                  )
                }}
              />
            </Box>
            <Box display="flex" alignItems="center" bgcolor={theme.colors.supplementary} borderRadius="5.125em">
              <Button design='secondary' startIcon={<StyledFilterIcon />} onClick={() => setIsDrawerOpen(true)}>
                Filter
              </Button>
            </Box>
          </Box>
          <Box display="flex" width="100%">
            <TableContainer component={Paper} className={classes.container}>
              <InfiniteScroll
                styles={styles.infiniteScroll}
                {...props}
                scrollThreshold="100px"
                loader={hasMore && <Loader />}
                dataLength={reportedUsers?.length || 0}
                hasMore={hasMore}
                next={() => fetchMore()}
                endMessage={
                  <StyledEndText>
                    {isLoading && <Loader />}
                    {totalCount === 0 && !!searchCriteria && !isLoading && 'No report found matching search keyword'}
                    {totalCount === 0 && !!searchCriteria === false && !isLoading && 'No reported user'}
                    {!!reportedUsers?.length &&
                      totalCount === reportedUsers?.length &&
                      !isLoading &&
                      'No more reported users'}
                  </StyledEndText>
                }
                scrollableTarget="reportedUsers"
                height={'70vh'}
              >
                <Table aria-label="simple table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {listHeadline?.map(title => (
                        <StyledHeadTableCell key={title} align="left">
                          {title}
                        </StyledHeadTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody id="reportedUsers">
                    {reportedUsers &&
                      reportedUsers?.map(user => (
                        <StyledTableRow key={user.id}>
                          <StyledTableCell align="left">{user?.blockedUserName}</StyledTableCell>
                          <StyledTableCell align="left">{user?.comments?.reason}</StyledTableCell>
                          <StyledTableCell align="left">{user?.role}</StyledTableCell>
                          <StyledTableCell align="left">
                            {user?.type.charAt(0).toUpperCase() + user?.type.slice(1)}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <CustomIconContextMenu
                              title=""
                              menuWidth="17em"
                              icon={<ActionContextIcon fill={theme.colors.accent1} />}
                              customItemPadding={'0'}
                            >
                              <StyledReportContentIconButton
                                size="small"
                                onClick={() => {
                                  setUserId(user?.id)
                                  user?.type === ReportedUserType.BLOCKED
                                    ? setOpenUnblockModal(true)
                                    : setOpenUnsuspendModal(true)
                                }}
                              >
                                <StyledReportedUserTypeTextWrapper>
                                  <Box>{user?.type === ReportedUserType.BLOCKED ? <BlockUser /> : <SuspendUser />}</Box>
                                  <StyledReportedUserTypeText>
                                    {user?.type === ReportedUserType.BLOCKED
                                      ? ReportedUserType.UNBLOCK
                                      : ReportedUserType.UNSUSPEND}
                                  </StyledReportedUserTypeText>
                                </StyledReportedUserTypeTextWrapper>
                              </StyledReportContentIconButton>
                            </CustomIconContextMenu>
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                </Table>
              </InfiniteScroll>
            </TableContainer>
          </Box>
        </Box>
      </Box>
      <SearchFilterDrawer actionType="User" />
      <ConfirmationDialog
        open={isConfirmed}
        onClose={() => {
          setIsConfirmed(false)
        }}
        onConfirm={() => handleConfirm(isConfirmed && openUnblockModal ? 'Admin unblocked user' : 'Unsuspend user')}
        message={
          <StyledUnblockMessage>{`Are you sure you want to ${isConfirmed && openUnblockModal ? ReportedUserType.UNBLOCK : ReportedUserType.UNSUSPEND
            } the User?`}</StyledUnblockMessage>
        }
        okBtnLabel="OK"
        cancelBtnLabel="CANCEL"
      />
      <ReportModal
        show={openUnblockModal ? openUnblockModal : openUnsuspendModal}
        title={openUnblockModal ? 'Unblock User' : 'Unsuspend User'}
        onClose={() => {
          setOpenUnsuspendModal(false)
          setOpenUnblockModal(false)
        }}
        textareaInputProps={{
          name: `${openUnblockModal ? 'unblock-user' : 'unsuspend-user'}`,
          placeholder: `Type your reason to ${openUnblockModal ? 'unblock' : 'unsuspend'} the user....`,
          value: resolution,
          onChange: handleResolutionChange
        }}
        buttonProps={{
          label: openUnblockModal ? 'Unblock' : 'Unsuspend',
          onClick: () => {
            setIsConfirmed(true)
          },
          disabled: resolution?.length <= 0
        }}
      />
    </AdminContainer>
  )
}

export default observer(ReportedUserList)
